var storefrontApp = angular.module('storefrontApp');
storefrontApp.component('vcAddress', {
    templateUrl: "themes/assets/js/common-components/address.tpl.html",
    bindings: {
        address: '=',
        addresses: '<',
        countries: '<',
        defaultFirstName: '<',
        defaultLastName: '<',
        validationContainer: '<',
        getCountryRegions: '&',
        editMode: '<',
        onUpdate: '&',
        onSelected: '&',
        allowEdit: '<'
    },
    require: {
        checkoutStep: '?^vcCheckoutWizardStep'
    },
    controller: ['$scope', function ($scope) {
        var ctrl = this;
        ctrl.isFormDisabled = false;

        this.$onInit = function () {
            if (ctrl.validationContainer)
                ctrl.validationContainer.addComponent(this);
            if (ctrl.checkoutStep)
                ctrl.checkoutStep.addComponent(this);
        };

        this.$onDestroy = function () {
            if (ctrl.validationContainer)
                ctrl.validationContainer.removeComponent(this);
            if (ctrl.checkoutStep)
                ctrl.checkoutStep.removeComponent(this);
        };

        ctrl.unlockEditing = function () { ctrl.address.editStatus = "Edited"; };

        ctrl.cancelEditing = function () {
            var originalAddress =  _.find(ctrl.addresses, function (addr) { return addr.key === ctrl.address.memberAddressId; });
            copyAddress(originalAddress, ctrl.address);
        };

        function copyAddress (source, dest) {
            dest.name = source.name;
            dest.firstName = source.firstName;
            dest.lastName = source.lastName;
            dest.organization = source.organization;
            dest.line1 = source.line1;
            dest.line2 = source.line2;
            dest.city = source.city;
            dest.regionId = source.regionId;
            dest.postalCode = source.postalCode;
            dest.countryCode = source.countryCode;
            dest.editStatus = null;
        }

        function populateRegionalDataForAddress(address) {
            if (address) {
                //Set country object for address
                address.country = _.findWhere(ctrl.countries, { code3: address.countryCode });
                if (address.country != null) {
                    ctrl.address.countryName = ctrl.address.country.name;
                    ctrl.address.countryCode = ctrl.address.country.code3;
                }

                if (address.country) {
                    if (address.country.regions) {
                        setAddressRegion(address, address.country.regions);
                    }
                    else {
                        ctrl.getCountryRegions({ country: address.country }).then(function (regions) {
                            address.country.regions = regions;
                            setAddressRegion(address, regions);
                        });
                    }
                }
            }
        }

        function setAddressRegion(address, regions) {
            address.region = _.findWhere(regions, { code: address.regionId });
            if (address.region) {
                ctrl.address.regionId = ctrl.address.region.code;
                ctrl.address.regionName = ctrl.address.region.name;
            }
            else {
                ctrl.address.regionId = undefined;
                ctrl.address.regionName = undefined;
            }
        }

        ctrl.setForm = function (frm) {
            ctrl.form = frm;
        };

        ctrl.validate = function () {
            if (ctrl.form) {
                ctrl.form.$setSubmitted();
                return ctrl.form.$valid;
            }
            return true;
        };

        ctrl.createNewAddress = function () {
            ctrl.setUnsubmitted();
            ctrl.address = {
                countryCode: 'USA',
                firstName: ctrl.defaultFirstName,
                lastName: ctrl.defaultLastName,
                editStatus: "New",
                memberAddressId: generateVirtoId()
            };
        }

        ctrl.cancelNewAddress = function () { 
            ctrl.setUnsubmitted();
            ctrl.address = null;
        }

        ctrl.setUnsubmitted = function() {
            if (ctrl.form) {
                ctrl.form.$setPristine();
                ctrl.form.$setUntouched();
            }
        };

        function stringifyAddress(address) {
            var stringifiedAddress = address.firstName + ' ' + address.lastName + ', ';
            stringifiedAddress += address.organization ? address.organization + ', ' : '';
            stringifiedAddress += address.line1 + ', ';
            stringifiedAddress += address.line2 ? address.line2 + ', ' : '';
            stringifiedAddress += address.city + ', ';
            stringifiedAddress += address.regionId ? address.regionId + ', ' : '';
            stringifiedAddress += address.postalCode + ', ';
            stringifiedAddress += address.countryCode;
            return stringifiedAddress;
        }


        $scope.$watch('$ctrl.addresses', function (newValue, oldValue) {
            // TODO:  Handle race condition for mainContext.customer.addresses being loaded after this component is initialized.  This only exists if ShippingAddress is first step.
            if (!oldValue && newValue && newValue.length && ctrl.address && ctrl.address.editStatus === 'New') {                
                ctrl.address = null;
            }
        });

        $scope.$watch('$ctrl.address', function (newValue, oldValue) {

            // 1. A placeholder option will null.
            // 2. A new address will have EditStatus set to 'New' and a virto id set
            // 3. A valid existing address will have a valid Virto Id for the key/memberAddressId
            // 4. If there aren't any addresses in the address list, this could still be a new or edit form for account addresses.


            // Scenario 1:  Addresses from account/address forms or from checkout but there aren't any existing addresses
            if (!ctrl.addresses || !ctrl.addresses.length) {
                if (newValue) {
                    ctrl.address.name = stringifyAddress(ctrl.address);
                }
                else {
                    ctrl.createNewAddress();
                }
            }
            // Scenario 2:  Address form with address selector.  Address form selected will have a placeholder with a blank value as well as a dummy record for new addresses.  The key and memberAddressId will be set to 'new'.
            else {

                if (newValue) {
                    // handle changes to value of selected address
    
                    if (!newValue.memberAddressId && (!oldValue || oldValue.memberAddressId !== newValue.memberAddressId)) {
                        // if 
                        //console.log('Placeholder selected', oldValue, newValue);
                        ctrl.address = null;
                    }
                    else if (!newValue.memberAddressId && oldValue && oldValue.memberAddressId) {
                        clearAddress();
                        ctrl.address.editStatus = 'New';
                        ctrl.address.memberAddressId = generateVirtoId();
                    }
                    // else if (newValue.memberAddressId && !newValue.city) {
                    //     // assume this is a default address setter
                    //     // NOTE:  This may not be needed any more since we're not setting a default address.
                    //     selectAddress();
                    // }
                    else if (!newValue.editStatus) {  
                        //console.log('select in case original address was edited.  Fixes Trello card https://trello.com/c/Q5p66MFF', oldValue, newValue);
                        // select in case original address was edited.  Fixes Trello card https://trello.com/c/Q5p66MFF
                        selectAddress();
                    }
                    else {
                        ctrl.address.name = stringifyAddress(ctrl.address);
                    }
                }
                else {
                    // Placed holder was selected
                    // Yes, for new form
                    //console.log('else for newValue - placeholder selected?');
                    ctrl.address = null;
                }
            }

            populateRegionalDataForAddress(ctrl.address);

            ctrl.isFormDisabled = ctrl.address && ctrl.address.memberAddressId && ctrl.address.editStatus !== 'New' && ctrl.address.editStatus !== 'Edited';

            ctrl.onUpdate({ address: ctrl.address });            
        }, true);

        function selectAddress() {
            var selectedAddress = _.findWhere(ctrl.addresses, { key: ctrl.address.memberAddressId });
            if (selectedAddress) {
                populateAddress(selectedAddress);

                if (ctrl.onSelected) {
                    ctrl.onSelected({ address: selectedAddress});
                }
            }            
        }

        function populateAddress(address) {
            ctrl.address.name = address.name;
            ctrl.address.firstName = address.firstName;
            ctrl.address.lastName = address.lastName;
            ctrl.address.organization = address.organization;
            ctrl.address.line1 = address.line1;
            ctrl.address.line2 = address.line2;
            ctrl.address.city = address.city;
            ctrl.address.regionId = address.regionId;
            ctrl.address.postalCode = address.postalCode;
            ctrl.address.countryCode = address.countryCode;
            ctrl.address.editStatus = null;
        }

        function clearAddress() {
            ctrl.address.key = null;
            ctrl.address.name = '';
            ctrl.address.firstName = ctrl.defaultFirstName;
            ctrl.address.lastName = ctrl.defaultLastName;
            ctrl.address.organization = '';
            ctrl.address.line1 = '';
            ctrl.address.line2 = '';
            ctrl.address.city = '';
            ctrl.address.regionId = '';
            ctrl.address.postalCode = '';
            ctrl.address.countryCode = 'USA';
        }

        function generateVirtoId() {
            // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
            var d = new Date().getTime();
            if (Date.now) {
                d = Date.now(); //high-precision timer
            }
            var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid;
        };
    }]
});
